import {
  ADD_CAR_DATA,
  UPDATE_CAR_DATA,
  CHAKBOX_LIST,
  SET_CHECKLIST_SELECTIONS,
  GAT_CAR_DETAIL_LIST,
  GAT_CAR_DETAIL,
  IMAGE_LIST,
  SET_CAR_REQUEST,
  ADD_CAR_DATA_MAIN,
  ADD_DAMAGE_DATA_MAIN,
  UPDATE_IMAGES_,
} from "./types";
import {
  sanitizeCarPicsPayload,
  sanitizeImageUrl,
} from "../../utils/sanitizeImageUrl";

export const getcardata = (data) => ({
  type: ADD_CAR_DATA,
  payload: sanitizeCarPicsPayload(data),
});

export const setcarquestionloading = (data) => ({
  type: SET_CAR_REQUEST,
  payload: data,
});

export const getcardetaol_ = (data) => ({
  type: GAT_CAR_DETAIL,
  payload: data,
});

export const getcardetailist = (data) => ({
  type: GAT_CAR_DETAIL_LIST,
  payload: data,
});

export const inp_chk_action = (data) => ({
  type: CHAKBOX_LIST,
  payload: data,
});

export const setChecklistSelections = (data) => ({
  type: SET_CHECKLIST_SELECTIONS,
  payload: data,
});

export const img_list_action = (data) => ({
  type: IMAGE_LIST,
  payload: data,
});

export const updatedata = (data, index) => ({
  type: UPDATE_CAR_DATA,
  payload: sanitizeCarPicsPayload(data),
  index,
});

export const add_Damagedata = (data) => {
  const item = data?.image
    ? { ...data, image: sanitizeImageUrl(data.image) }
    : data;
  return {
    type: ADD_DAMAGE_DATA_MAIN,
    payload: { data: item },
  };
};

export const add_newdata = (data) => {
  const item = data?.image
    ? { ...data, image: sanitizeImageUrl(data.image) }
    : data;
  return {
    type: ADD_CAR_DATA_MAIN,
    payload: { data: item },
  };
};

export const update_car_imges = (data, index) => ({
  type: UPDATE_IMAGES_,
  payload: data,
  index,
});
